import { apiCall } from './generated/gqlClient';

const createSubscriptionAsAnonymousApiRequest = async request => {
  const mutation = `
    mutation createSubscriptionAsAnonymous($classId: Int!, $sessions: [Int]!, $email: String!) {
      createSubscriptionAsAnonymous(classId: $classId, sessions: $sessions, email: $email) {
        id
        message
        success
        amount
        amountCents
        clientSecret
        stripeAccount
      }
    }
  `;

  return apiCall({ query: mutation, variables: request });
};

const cancelSubscriptionApiRequest = async subscriptionId => {
  const mutation = `
    mutation cancelSubscription($subscriptionId: Int!) {
      cancelSubscription(subscriptionId: $subscriptionId) {
        success
        message
        id
      }
    }
  `;

  return apiCall({ query: mutation, variables: { subscriptionId } });
};

const cancelSubscriptionSessionApiRequest = async (subscriptionId, sessionId) => {
  const mutation = `
    mutation cancelSubscriptionSession($subscriptionId: Int!, $sessionId: Int!) {
      cancelSubscriptionSession(subscriptionId: $subscriptionId, sessionId: $sessionId) {
        success
        message
        id
      }
    }
  `;

  return apiCall({ query: mutation, variables: { subscriptionId, sessionId } });
};

const getSubscriptionsBySessionIdApiRequst = async sessionId => {
  const query = `
    query getSubscriptionsBySession($sessionId: Int!) {
      getSubscriptionsBySession(sessionId: $sessionId) {
        id
        providerId
        serviceId
        classId
        total
        status
        email
        code
        presence
        sessions {
          id
          status
        }
        user {
          id
          name
          firstname
          lastname
          email
          timezone
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        userInfo {
          firstname
          lastname
          email
          phone
        }
        order {
          id
        }
      }
    }
  `;
  return apiCall({ query, variables: { sessionId } });
};

const getCanceledSubscriptionsBySessionApiRequest = async sessionId => {
  const query = `
    query getCanceledSubscriptionsBySession($sessionId: Int!) {
      getCanceledSubscriptionsBySession(sessionId: $sessionId) {
        id
        providerId
        serviceId
        classId
        total
        status
        email
        code
        cancelled
        cancelledBy
        sessions {
          id
          status
        }
        user {
          id
          name
          firstname
          lastname
          email
          timezone
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        visitatore {
          id
          name
          firstname
          lastname
          email
        }
        userInfo {
          firstname
          lastname
          email
          phone
        }
        order {
          id
        }
      }
    }
  `;
  return apiCall({ query, variables: { sessionId } });
};

const getSubscriptionPriceApiRequest = async request => {
  const query = `
    query getSubscriptionPrice($request: SubscriptionPriceRequest!) {
      getSubscriptionPrice(request: $request) {
        price
        priceWithoutDiscount
      }
    }
  `;
  // The query takes one $request object: { classId, sessions } goes inside it.
  return apiCall({ query, variables: { request } });
};

// Sposta iscrizione (#1713): the class's coming sessions one session of a subscription can move to:
// [{ id, startTime, endTime, capacity, taken, full, alreadyIn, staff }].
const getSessionsForSubscriptionMoveApiRequest = async (subscriptionId, sessionId) =>
  apiCall({
    query: `
    query getSessionsForSubscriptionMove($subscriptionId: Int!, $sessionId: Int!) {
      getSessionsForSubscriptionMove(subscriptionId: $subscriptionId, sessionId: $sessionId)
    }`,
    variables: { subscriptionId, sessionId },
  });

// Sposta iscrizione (#1713): { success, id, waitingList }.
const moveSubscriptionSessionApiRequest = async ({ subscriptionId, fromSessionId, toSessionId, overlapConfirmed }) =>
  apiCall({
    query: `
    mutation moveSubscriptionSession($subscriptionId: Int!, $fromSessionId: Int!, $toSessionId: Int!, $overlapConfirmed: Boolean) {
      moveSubscriptionSession(subscriptionId: $subscriptionId, fromSessionId: $fromSessionId, toSessionId: $toSessionId, overlapConfirmed: $overlapConfirmed)
    }`,
    variables: { subscriptionId, fromSessionId, toSessionId, overlapConfirmed: !!overlapConfirmed },
  });

// Sposta partecipanti (#1713): what happens to each one if moved —
// [{ id, status: 'in' | 'waitingList' | 'overlap' | 'refused', place, position, error }].
const checkSubscriptionsSessionMoveApiRequest = async ({ fromSessionId, toSessionId, subscriptionIds }) =>
  apiCall({
    query: `
    query checkSubscriptionsSessionMove($fromSessionId: Int!, $toSessionId: Int!, $subscriptionIds: [Int]!) {
      checkSubscriptionsSessionMove(fromSessionId: $fromSessionId, toSessionId: $toSessionId, subscriptionIds: $subscriptionIds)
    }`,
    variables: { fromSessionId, toSessionId, subscriptionIds },
  });

// Sposta partecipanti (#1713): [{ id, success, waitingList, position, error }].
const moveSubscriptionsSessionApiRequest = async ({ fromSessionId, toSessionId, subscriptionIds, overlapConfirmedIds }) =>
  apiCall({
    query: `
    mutation moveSubscriptionsSession($fromSessionId: Int!, $toSessionId: Int!, $subscriptionIds: [Int]!, $overlapConfirmedIds: [Int]) {
      moveSubscriptionsSession(fromSessionId: $fromSessionId, toSessionId: $toSessionId, subscriptionIds: $subscriptionIds, overlapConfirmedIds: $overlapConfirmedIds)
    }`,
    variables: { fromSessionId, toSessionId, subscriptionIds, overlapConfirmedIds: overlapConfirmedIds || [] },
  });

export {
  cancelSubscriptionApiRequest,
  cancelSubscriptionSessionApiRequest,
  checkSubscriptionsSessionMoveApiRequest,
  createSubscriptionAsAnonymousApiRequest,
  getCanceledSubscriptionsBySessionApiRequest,
  getSessionsForSubscriptionMoveApiRequest,
  getSubscriptionPriceApiRequest,
  getSubscriptionsBySessionIdApiRequst,
  moveSubscriptionSessionApiRequest,
  moveSubscriptionsSessionApiRequest,
};
